export default "__VITE_ASSET__BKcBfClp__"